import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { MedicationAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-medication-slot',
    templateUrl: './medication-slot.component.html',
    styleUrl: './medication-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationSlotComponent implements SheetSlotComponentBase {

	action!: MedicationAction;
	value!: string | null;

	@Input('action') set updateAction(action: MedicationAction | null) {
		this.action = action as MedicationAction;
		this.value = this.action.amountGiven?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}